export default "__VITE_ASSET__czuHXl48__"